<template>
    <div>
        <h1>
            PROCESANDO...
        </h1>
    </div>    
</template>

<script>

import store from "../../store";



export default {
    name: "Front",
    data() {
    return {
      raw: "",
      key: "",
      user: "",

    };
  },
    mounted(){
      this.checkStorage()
      this.keepParams()
      
    },
    methods: {
      checkStorage(){
      if(localStorage.getItem('uid') == null ){
            this.$router.push("/home");
      }else{
        console.log("aqui no hay nada" ,localStorage.getItem("uid"),localStorage.getItem("pass"))
      }
       },
        keepParams (){
          var params = "";
          var rawParams = window.location.hash;
          var cortado = "";
          var lastCut1 = ""
          var lastCut2 = ""
          console.log("QUE LLEGA AQUI?",rawParams)
          
          cortado = rawParams.split("?")
          console.log("que llega a cortado",cortado)
          params= cortado[1].split("&")
          console.log("Que llega a params", params)
          lastCut1 = params[0].split("=")
          lastCut2 = params[1].split("=")

          console.log("corte final 1", lastCut1)
          console.log("corte final 2", lastCut2)
          

          this.key = lastCut1 [1]
          this.user = lastCut2[1]
          

          
          localStorage.setItem("uid", this.user);
          localStorage.setItem("pass", this.key);

          

          
          setTimeout(()=>{
          location.reload();
            
        },500)
          
          //var decryptedText = this.$CryptoJS.AES.decrypt(paramtest, "Apache5449275957", { iv: this.vector })
          //console.log("Que me sale por aqui",decryptedText)
        },

        /*handleLogin() {
      
      let user = this.user;
      let password = this.key;
      store
        .dispatch("login", { user, password })
        .then(() => {
          const res = store.getters.getAuthStatus;
          if (res == "success") {
            this.$router.push("/home");
          } else {
            //this.$router.push("/login");
            console.log("no he pasado")
          }
        })
        .catch(err => console.log(err));
     }*/
      }
}
</script>

<style>

</style>